import { eventsApi } from './events';
import { sharingApi } from './sharing';
import { LIST_OF_CALENDAR_ACTIVITIES } from './listOfCalendarActivities';

export * from './types';
export * from './usaCalendar';
export * from './useCalendarFormOptions';

export const calendarApi = {
  listOfCalendarActivities: LIST_OF_CALENDAR_ACTIVITIES,
  events: eventsApi,
  sharing: sharingApi,
};
